<script>
import VTooltipWrapper from "../../../../common/v-tooltip-wrapper.vue";
import {getIconType, getTitle} from "../../../elements/utility";
import CalendarEvent from "./CalendarEvent";

export default {
    name: "calendar-element-type-icon",
    components: {VTooltipWrapper},
    props: {
        event: {
            type: CalendarEvent,
            required: true
        },
    },
    computed: {
        kind() {
            return getIconType(this.event.elementData?.data?.type, this.event.elementData?.data?.dynamic);
        },
        title() {
            return getTitle(this.kind);
        },
    }
}
</script>

<template>
    <v-tooltip-wrapper>
        <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on" class="calendar-event-type">
                <eicon v-if="kind" :kind="kind"/>
            </span>
        </template>
        <div class="icon-in-tooltip-container">
            {{title}}
        </div>
    </v-tooltip-wrapper>
</template>

<style scoped>
.calendar-event-type {
    display: flex;
    justify-content: center;
    padding-top: 1px;
    font-size: 12px;
    z-index: 1;

    .eicon-original-color {
        color: inherit !important;
    }
}
</style>
